import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  title,
  children,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border border-zinc-800 rounded-xl mb-3 overflow-hidden bg-zinc-900/50" data-id="element-3">
      <button className="w-full px-5 py-4 flex items-center justify-between text-left focus:outline-none" onClick={onClick} data-id="element-4">
        <span className="font-semibold text-zinc-100 pr-4" data-id="element-5">{title}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 text-pink-500" data-id="element-6">
          <ChevronDown size={20} data-id="element-7" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-8">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-9">
            <div className="px-5 pb-4 text-zinc-400" data-id="element-10">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    title: string | React.ReactNode;
    content: React.ReactNode;
  }[];
  allowMultiple?: boolean;
}
export function Accordion({
  items,
  allowMultiple = false
}: AccordionProps) {
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);
  const handleToggle = (index: number) => {
    if (allowMultiple) {
      setOpenIndexes(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
    } else {
      setOpenIndexes(prev => prev.includes(index) ? [] : [index]);
    }
  };
  return <div className="w-full" data-id="element-11">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} isOpen={openIndexes.includes(index)} onClick={() => handleToggle(index)} data-id="element-12">
          {item.content}
        </AccordionItem>)}
    </div>;
}